import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { fetchText, flattenDocs } from "@/lib/docs";

const DocsContext = createContext(null);

export const DocsProvider = ({ children }) => {
  const [manifest, setManifest] = useState(null);
  const [texts, setTexts] = useState({});
  const [failed, setFailed] = useState({});
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchText("manifest.json")
      .then((raw) => {
        const m = JSON.parse(raw);
        setManifest(m);
        flattenDocs(m).forEach((d) =>
          fetchText(d.path)
            .then((t) => setTexts((prev) => ({ ...prev, [d.path]: t })))
            .catch(() => setFailed((prev) => ({ ...prev, [d.path]: true }))),
        );
      })
      .catch((e) => setError(e.message));
  }, []);

  const docs = useMemo(() => (manifest ? flattenDocs(manifest) : []), [manifest]);
  const value = useMemo(() => ({ manifest, docs, texts, failed, error }), [manifest, docs, texts, failed, error]);

  return <DocsContext.Provider value={value}>{children}</DocsContext.Provider>;
};

export const useDocs = () => useContext(DocsContext);
